import { render } from "./404.html?vue&type=template&id=086714ac&scoped=true&ts=true"
import script from "./404.ts?vue&type=script&lang=ts"
export * from "./404.ts?vue&type=script&lang=ts"

import "./404.scss?vue&type=style&index=0&id=086714ac&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-086714ac"]])

export default __exports__